import { isMobile } from './02-slideshare_player_controller'
import SSShareWidgets from './00-slideshare_share_widgets';

function SSLastScreen(config){
  this.config = config;
  this._init();
}

SSLastScreen.prototype._init = function(){
  this.isVisible = false;
  this.isShareScreenVisible = false;
  this.gaCategory = 'lastscreen_v1_';
  this.$container = $('#lastScreen');
  this.$nextButton = $('#btnNext .j-next-btn');

  this.$container.find('img.j-thumbnail').lazyload({
    effect: 'fadeIn',
    event: 'loadThumb'
  });
};

SSLastScreen.prototype.exitFullScreenIfIdle = function(){
  var exit_screen = setTimeout(function(){
    if($('.lastScreen').is(':visible')){
      if(!$.browser.mozilla){
        $('.btnLeaveFullScreen').trigger('click');
      }
    }
  }, 5000);
  $('.lastScreen').on('click',function(){
    clearTimeout(exit_screen);
  });
};

SSLastScreen.prototype.show = function(dimensions, isFullScreen){
  // Load related thumbs
  this.$container.find('img.j-thumbnail').trigger('loadThumb');
  this.isVisible = true;
  if (this.overlay !== undefined){
    this.overlay.show();
    this.lastScreen.show();
    return;
  }

  var lastScreenClass = 'lastScreenContainer';
  if(isMobile()){
    lastScreenClass += ' mobile';
  }
  this.lastScreen = this.$container.addClass(lastScreenClass).appendTo(this.config.renderTo);
  this.lastScreen.show();
  this.overlay  = this.lastScreen.find('.j-last-screen-overlay');
  this.setDimensions();
  this.populateTemplate();
  isFullScreen && this.exitFullScreenIfIdle();
};

SSLastScreen.prototype.populateTemplate = function(){
  this.lastScreen.find('.lastScreenEmbedCode, .j-share-embed-link').val(this.config.embed_code);
  this.lastScreen.find('.lastScreenSSUrl, .j-share-link-url').val(this.config.settings.url);
  this.lastScreen.find('.j-share-embed-wp').val(this.config.wp_code);
  $.fn.tooltip && this.lastScreen.find('.j-tooltip').tooltip();
  if(this.config.disableRelated){
    this.lastScreen.find('.lastScreen').addClass('j-disable-related');
    this.config.disableShare && this.lastScreen.find(".lastScreen").addClass('j-disable-share');
    this.isProLastScreen = true;
  }
  this._bindEvents();
  this.initShareWidget();
  this.populateEmbedSizes();
};

SSLastScreen.prototype.initShareWidget = function(){
  this.shareWidgets = new SSShareWidgets({
    "container": this.lastScreen,
    "gaCategory": this.gaCategory
  });
};

SSLastScreen.prototype.populateEmbedSizes = function(){
  var embedSizesPicker = this.lastScreen.find('.j-embed-size-picker');
  $.each(this.config.embed_sizes.presets, function(key, value){

    var displayWidth = value.size.width + 4;
    var displayHeight = value.size.height + 2;

    var option = $('<option/>').val(key).text(displayWidth+'x'+displayHeight);
    embedSizesPicker.append(option);
  });
  embedSizesPicker.val(this.config.embed_sizes.config.defaultPreset).change();
};

SSLastScreen.prototype._bindEvents = function(){

  $('.lastscreen-share-cta').bind('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    $.slideshareEventManager.trigger('playershare', this.gaCategory);
  });

  var that = this;
  var emailCta = this.lastScreen.find('.j-email-cta');

  emailCta.bind('click', function(){
    $.slideshareEventManager.trigger('playershare', this.gaCategory);
    that.lastScreen.find('.j-share-email-to').click();
    that.lastScreen.find('.j-share-email-to').focus();
    $.slideshareEventManager.trackEvent(that.gaCategory + 'email_cta');
  });

  this.lastScreen.find('.j-last-screen-replay').bind('click', function(e){
    e.preventDefault();
    e.stopPropagation();
    that.hide();
    $.slideshareEventManager.trigger('gotofirstslide');
    $.slideshareEventManager.trackEvent(that.gaCategory + 'replay');
  });
  this.lastScreen.find('.j-last-screen-overlay, .j-lastscreen-close').bind('click', function(){
    that.hide();
  });
  this.lastScreen.find('.j-lastscreen-related a').bind('click', function(event) {
    $.slideshareEventManager.trackEvent(that.gaCategory + 'relatedclick');
  });
};

SSLastScreen.prototype.showShareScreen = function(config){
  // Store lastscreen state for restore on modal share close
  this.shareOpenedFromLastScreen = this.isVisible;

  if (!this.isShareScreenVisible) {
    this.isShareScreenVisible = true;
    this.show();
    this.lastScreen.find('.j-lastscreen').hide();

    if(config.customizations.title){
      var titleElement = this.lastScreen.find("a#button-share-tab");
      titleElement.text(config.customizations.title);
    }
    this.lastScreen.find('#last-screen-modal-share').show();
  } else {
    this.hide();
  }
};

SSLastScreen.prototype.restoreLastScreenState = function() {
  if (this.shareOpenedFromLastScreen) {
    this.lastScreen.find('.j-lastscreen').show();
  } else {
    this.lastScreen.find('.j-lastscreen').show();
    this.hide();
  }
};

SSLastScreen.prototype.hide = function(){
  this.isVisible = false;
  this.isShareScreenVisible = false;
  this.overlay.hide();
  this.lastScreen.hide();
};

SSLastScreen.prototype.destroy = function(){
  if(this.overlay){
    this.overlay.remove();
    delete(this.overlay);
  }
  if(this.lastScreen){
    this.lastScreen.remove();
    delete(this.lastScreen);
  }
};

SSLastScreen.prototype.setDimensions = function(){
  if (this.lastScreen === undefined){
    return;
  }

  this.config.lastScreenClass && this.lastScreen.find(".lastScreen").addClass(this.config.lastScreenClass);
};

export default SSLastScreen